import React from "react";
import TextField from "@material-ui/core/TextField";
import { Checkbox } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Row, Col } from "react-grid-system";

const useStyles = makeStyles({
  input_text: {
    fontFamily: "Open Sans Hebrew",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "18px",
    lineHeight: "23px",
    display: "flex",
    alignItems: "center",
    textAlign: "right",
    color: "#111617",
    opacity: 0.7,
  },
});

function ShowDaySelction(props) {
  var start = props.day + "_start";
  var end = props.day + "_end";
  var heb_day;
  var is_day_checked, start_time, end_time;
  const classes = useStyles();
  switch (props.day) {
    case "sunday":
      heb_day = "ראשון";
      is_day_checked = props.user.work_on_sunday.is_needed;
      start_time = props.user.work_on_sunday.start_time;
      end_time = props.user.work_on_sunday.end_time;
      break;
    case "monday":
      heb_day = "שני";
      is_day_checked = props.user.work_on_monday.is_needed;
      start_time = props.user.work_on_monday.start_time;
      end_time = props.user.work_on_monday.end_time;
      break;
    case "tuesday":
      heb_day = "שלישי";
      is_day_checked = props.user.work_on_tuesday.is_needed;
      start_time = props.user.work_on_tuesday.start_time;
      end_time = props.user.work_on_tuesday.end_time;
      break;
    case "wednesday":
      heb_day = "רביעי";
      is_day_checked = props.user.work_on_wednesday.is_needed;
      start_time = props.user.work_on_wednesday.start_time;
      end_time = props.user.work_on_wednesday.end_time;
      break;
    case "thursday":
      heb_day = "חמישי";
      is_day_checked = props.user.work_on_thursday.is_needed;
      start_time = props.user.work_on_thursday.start_time;
      end_time = props.user.work_on_thursday.end_time;
      break;
    case "friday":
      heb_day = "שישי";
      is_day_checked = props.user.work_on_friday.is_needed;
      start_time = props.user.work_on_friday.start_time;
      end_time = props.user.work_on_friday.end_time;
      break;
    case "saturday":
      heb_day = "שבת";
      is_day_checked = props.user.work_on_saturday.is_needed;
      start_time = props.user.work_on_saturday.start_time;
      end_time = props.user.work_on_saturday.end_time;
      break;
  }
  return (
    <Container>
      <Row className={classes.input_text}>
        <Col width="40%">
          {" "}
          <Checkbox
            name={props.day}
            defaultChecked={is_day_checked}
            value="secondary"
            color="primary"
            inputProps={{ "aria-label": "secondary checkbox" }}
          />{" "}
          {heb_day}
        </Col>
        <Col width="30%">
          <TextField
            name={start}
            label="התחלה"
            type="time"
            defaultValue={start_time}
            InputLabelProps={{ shrink: true }}
            inputProps={{ step: 1800 }}
          />
        </Col>
        <Col width="30%">
          <TextField
            name={end}
            label="סיום"
            type="time"
            defaultValue={end_time}
            InputLabelProps={{ shrink: true }}
            inputProps={{ step: 1800 }}
          />
        </Col>
      </Row>
    </Container>
  );
}
export default ShowDaySelction;
